module.exports = __webpack_public_path__ + "img/DealerIcons-HundredSeries-Off.8e8ea2d.jpg";